module.exports = __webpack_public_path__ + "static/img/sport_into.b95cf9cc.png";